import React from "react";
import "./ExchangeBlock.css";
import ExchangeInfo from "./ExchangeInfo/ExchangeInfo";
import SimpleExchange from "./SimpleExchange/SimpleExchange";

const ExchangeBlock = () => {
    return (
        <div className="exchange-container">
            <ExchangeInfo/>

            <SimpleExchange />
        </div>
    );
};

export default ExchangeBlock;
